import { useContext } from 'react';
import { RelatedArticlesContext } from '../contexts';
export default function useRelatedArticles() {
    const relatedArticles = useContext(RelatedArticlesContext);
    return relatedArticles;
}
//# sourceMappingURL=useRelatedArticles.js.map